import 'core-js/modules/es6.array.find';
import 'core-js/es6/promise';
import browser from 'browser-detect';


/**
 * Fallback for missing flex support on older browsers
 */
let no_flex = false;
let browser_details = browser();
if (browser_details.name === "safari" && browser_details.versionNumber < 9) {
    no_flex = true;
}

/**
 * Facebook IAB pretends to be safari 4.0.0 for some reason. it most often isn't
 */
if (navigator.userAgent.includes('FB_IAB')) {
    no_flex = false;
}

if (no_flex) {
    window.jQuery('body').addClass('no-flexbox');
}
